<markant-card class="ui-card" [outlined]="true">
  <div slot="markant-card__headline" class="ui-card-header">
    <h4 *ngIf="!!headline" class="ui-card-headline" [title]="headline">
      {{ headline }}
    </h4>
    <ng-content select="[action-buttons]"></ng-content>
  </div>
  <div slot="markant-card__content">
    <ng-content></ng-content>
  </div>
  <div slot="markant-card__footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</markant-card>
